import { memo } from 'react';
import { Box, styled } from '@mui/system';
import { themeShadows } from 'app/components/Theme/themeColors';
import { sidenavCompactWidth, sideNavWidth } from 'app/utils/constant';

import Brand from '../../Brand';
import Sidenav from '../../Sidenav';
import { useSelector } from 'react-redux';
import SidebarTop from 'app/views/dashboard/components/SidebarTop';

const SidebarNavRoot = styled(Box)(({ theme, width }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100vh',
  width: width,
  boxShadow: themeShadows[8],
  zIndex: 111,
  overflow: 'hidden',
  color: theme.palette.text.primary,
  transition: 'all 250ms ease-in-out',
  //backgroundImage: `linear-gradient(to bottom, rgba(${primaryBg}, 0.96), rgba(${primaryBg}, 0.96)), url(${bgImgURL})`,
  //backgroundRepeat: 'no-repeat',
  //backgroundPosition: 'top',
  //backgroundSize: 'cover',
  backgroundColor:"#FFF",// theme.palette.primary.main,
  '&:hover1': {
    width: sideNavWidth,
    '& .sidenavHoverShow': {
      display: 'block',
    },
    '& .compactNavItem': {
      width: '100%',
      maxWidth: '100%',
      '& .nav-bullet': {
        display: 'block',
      },
      '& .nav-bullet-text': {
        display: 'none',
      },
    },
  },
}));

const NavListBox = styled(Box)(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor:"#FFF",
}));

const Layout1Sidenav = ({ source }) => {
  const settings = useSelector(store=>store.settings);
  const leftSidebar = settings.layout1Settings.leftSidebar;
  const { mode } = leftSidebar;
 // const [hover,setHover] = useState(false);
  const hover = false;
  
  const getSidenavWidth = () => {
    switch (mode) {
      case 'compact':
        return sidenavCompactWidth;
      default:
        return sideNavWidth;
    }
  };
  //onMouseOver={()=>setHover(true)} and onMouseOut={()=>setHover(false)} 
  return (
    <SidebarNavRoot width={getSidenavWidth()}>
      <NavListBox>
        <Brand hover={hover} mode={mode}></Brand>
        <Sidenav hover={hover}>
          <SidebarTop source={source} hover={hover} mode={mode}/>
        </Sidenav>
      </NavListBox>
    </SidebarNavRoot>
  );
};

export default memo(Layout1Sidenav);
